import { useParams } from 'react-router-dom'

type PageParams = {
  objectiveId: string
  workflowId?: string
}

export const useCoursePageParams = () => {
  const { objectiveId, workflowId } = useParams() as PageParams

  return {
    objectiveId,
    workflowId,
  }
}
